import React, { FC }                               from 'react';
import { CorvalUIColor, CorvalUserLike, Position } from '../../../../types';
import { UserService }                             from '../../../../services';
import { StyledContainer }                         from '../../../containers';
import { HexagonShape, HexagonShapeProps }         from './HexagonShape';

export interface GravatarProps {
	size?: HexagonShapeProps['size'],
	user?: CorvalUserLike,
	
	[ additionalProps: string ]: any
}

const defaultProps: GravatarProps = {
	size: 200,
	user: null,
}

const Gravatar: FC<GravatarProps> = ( props ) => {
	
	let sizeMap = {
		innerHex:  Math.round( props.size * 0.20 ),
		middleHex: Math.round( props.size * 0.42 ),
		outerHex:  Math.round( props.size * 0.70 ),
	}
	
	return (
		
		<StyledContainer
			position={ Position.RELATIVE }
			style={ {
				height:          props.size,
				width:           props.size,
				backgroundColor: UserService.getUserColor( props.user )
			} }
			className={ 'overflow--hidden' }>
			
			<StyledContainer fill={ 'area' } className={ 'opacity--50' } zIndex={ 400 } style={ { top: `calc(49% - (${ Math.round( sizeMap.innerHex / 2 ) }px))` } }>
				<HexagonShape size={ sizeMap.innerHex } color={ CorvalUIColor.WHITE } rotation={ 30 }/>
			</StyledContainer>
			
			<StyledContainer fill={ 'area' } className={ 'opacity--50' } zIndex={ 300 } style={ { top: `calc(48% - (${ Math.round( sizeMap.middleHex / 2 ) }px))` } }>
				<HexagonShape size={ sizeMap.middleHex } color={ UserService.getUserColor( props.user ) } rotation={ 0 }/>
			</StyledContainer>
			
			<StyledContainer fill={ 'area' } className={ 'opacity--50' } zIndex={ 200 } style={ { top: `calc(46% - (${ Math.round( sizeMap.outerHex / 2 ) }px))` } }>
				<HexagonShape size={ sizeMap.outerHex } color={ CorvalUIColor.WHITE } rotation={ 0 }/>
			</StyledContainer>
		
		</StyledContainer>
	);
};

Gravatar.defaultProps = defaultProps;

export { Gravatar }
